<company-information
  [repairerSite]="repairerSite"
  [markerOptions]="markerOptions"
  [options]="options"
  (editCompanyAddress)="editAddressInterface()" />

<div class="header-container mt-45">
  <h3>Banking Details</h3>
  @if (currentUser?.privileges?.includes('REPADMIN')) {
    <div class="flex">
      <button matButton="elevated" class="charcoal-button" (click)="editBankingDetails()">
        {{ repairerSite?.bsb ? 'EDIT' : 'ADD' }}
      </button>
      @if (repairerSite?.bsb) {
        <div class="kebab-banking secondary-icon">
          <button matIconButton [matMenuTriggerFor]="bankingMenu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #bankingMenu="matMenu" class="kebab-menu">
            <button mat-menu-item (click)="confirmDeleteBankingDetails()">
              <span>Delete Banking Details</span>
            </button>
          </mat-menu>
        </div>
      }
    </div>
  }
</div>
<mat-divider />
<div class="banking-details-section">
  @if (!repairerSite?.bsb) {
    <div class="banking-info">
      <mat-icon>info_outlined</mat-icon>
      <span class="subtitle-2">
        Please add your banking details. They will be saved and available for future invoices.
      </span>
    </div>
  }
  @if (repairerSite?.bsb) {
    <div class="banking-grid">
      @for (property of bankingDetailsMap; track property.label) {
        <div>
          <div class="body-2">{{ property.label }}</div>
          <div class="subtitle-2">{{ property.value }}</div>
        </div>
      }
    </div>
  }
</div>

<job-notifications (refreshRepairerSite)="refresh()" />

<user-management
  [repairSiteStatus]="repairerSite?.status"
  [currentUser]="currentUser"
  (addEditUser)="addEditUser($event)"
  (enableDisableUser)="enableDisableUser($event)"
  (confirmDeleteInvitedUser)="confirmDeleteInvitedUser($event)" />

<history-of-company />
